<template>
  <div class="driver-panel-passenger-detail" :class="$store.state.theme">
    <div ref="scrollable" class="bottom-wrapper no-scrollbar">
      <div class="card">
        <div v-if="isDelivery && isLate">
          <div class="countdown-timer" @click="lateInfo">
            {{
              $t("driver.you-are-late-arrive-by-x", { x: hhmmTime(arriveBy) })
            }}
          </div>
          <progress class="progress is-small is-danger" />
        </div>

        <div v-if="showTUKExpressReminder" class="has-text-info tuk-express" @click="logAgentOrder">
          <p style="font-size: 1.1em; font-weight: 550">
            TUK Express
            <i class="is-pulled-right has-text-warning">Call customer from shop!</i>
          </p>
          <p>- Does customer phone work?</p>
          <!-- <p>- Is customer expecting delivery?</p> -->
          <p>- Is customer address correct?</p>
          <p class="has-text-warning">
            <i>Problem? Contact Support before leaving shop!</i>
          </p>
        </div>

        <div v-if="isGift" class="has-text-danger tuk-express">
          <p style="font-size: 1.1em; font-weight: 550">
            <i class="fa fa-gift" />&nbsp;Gift for Recipient:
            <span class="is-pulled-right has-text-info" @click="callRecipient">{{ t.data.gift_details.recipient_phone
            }}&nbsp;<i class="fa fa-phone" /></span>
            <!-- <i class="is-pulled-right has-text-warning"
              >Call customer from shop!</i
            > -->
          </p>
          <!-- <p>- Does customer phone work?</p> -->
        </div>

        <div v-if="scheduledTime(t) && showScheduleTag(t)">
          <p class="has-text-link scheduled">
            {{ $t("driver.scheduled-pickup-time") }}
            {{ scheduledTime(t) }} ({{ humanTimeOrTimeAgo(t) }})
          </p>
        </div>

        <div class="card-content is-flex" style="padding: 4px">
          <div v-if="showCancel">
            <button class="button is-medium is-danger is-outlined is-rounded" @click="cancel">
              {{ $t("driver.cancel-ride") }}
            </button>
          </div>

          <div v-if="showNoShow">
            <button v-if="isDelivery" class="button is-medium is-grey is-outlined is-rounded"
              @click="deliveryPickupIssue">
              <i class="fa fa-exclamation-triangle" />
            </button>
            <button v-else class="button is-medium is-grey is-outlined is-rounded" @click="noShow">
              {{ $t("driver.no-show") }}
            </button>
          </div>

          <!-- main action button for driver here -->
          <div style="flex-grow: 1">
            <button class="button is-medium is-link is-rounded is-fullwidth" v-if="t.state === 'confirmed'"
              @click="editTransaction('driver_arrived')">
              {{ $t("driver.arrived") }}
              <span v-if="isDelivery" class="countdown" :class="countdown > 1 ? 'has-text-success' : 'has-text-danger'">
                {{ countdown }}
                <i v-if="countdown < 1" class="fa fa-exclamation" />
              </span>
            </button>
            <button class="button is-medium is-success is-rounded is-fullwidth" v-if="t.state === 'driver_arrived'"
              @click="editTransaction('enroute')">
              {{ $t("driver.pickup") }}
              <i v-if="waitingTime > 20" class="far fa-hourglass fa-sm" style="margin-left: 10px" />
            </button>
            <button class="button is-medium is-warning is-rounded is-fullwidth" v-if="t.state === 'enroute'"
              @click="editTransactionAlighted">
              {{ $t("driver.dropoff") }}
              <span v-if="isDelivery && countdown" class="countdown"
                :class="countdown > 1 ? 'has-text-success' : 'has-text-danger'">
                {{ countdown }}
                <span v-if="countdown < 1">!!!</span>
              </span>
            </button>
          </div>

          <div v-if="isEnrouteDelivery" style="flex-shrink: 1">
            <button class="button is-medium has-text-success is-rounded" @click="deliveryArrived">
              <!-- {{ $t("driver.i-am-here") }} -->
              <i class="fa fa-bell" />
            </button>
          </div>
          <div v-if="isEnrouteDelivery" style="flex-shrink: 1">
            <button class="button is-medium is-rounded" @click="triggerUploadPhoto">
              <i v-if="photoUploading" class="fa fa-spinner fa-spin" />
              <i v-else class="fa fa-camera" :class="{
                pulse: contactlessNote && !t.data.delivery_confirmation_pic,
              }" />
            </button>
            <i v-if="t.data.delivery_confirmation_pic" class="fa fa-check-circle has-text-success"
              style="position: absolute; margin-left: -8px; margin-top: -4px" @click="viewDeliveryConfirmationPic" />
          </div>

          <div style="flex-shrink: 1">
            <button class="button is-medium is-rounded is-white close-btn" @click="close">
              <i class="fa fa-chevron-down fa-lg has-text-grey" />
            </button>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-content user">
          <div class="media">
            <div class="media-left" @click="close">
              <img class="profile-pic" :src="customerPic" />
            </div>
            <div class="media-content no-scrollbar">
              <p class="fare-wrapper">
                <span v-if="moreInfo || t.state === 'confirmed'">
                  <span v-if="isLalamove">
                    <span class="fare is-size-5" style="background-color: #eee">
                      ฿{{ t.data.fare.price }}
                    </span>
                    <span class="fare is-size-5">
                      <img src="../assets/tukpay.png" class="tukpay-logo" />
                    </span>
                  </span>
                  <span v-else>
                    <span class="fare is-size-5" style="background-color: #eee">
                      <span v-if="t.data.fare">฿{{ t.data.fare.price }}</span>
                      <span v-else class="has-text-success">FREE</span>
                      <span v-if="cash && tukpay"> {{ $t("total") }} </span>
                    </span>
                    <span v-if="!(cash && tukpay)" class="fare is-size-5">
                      <span v-if="cash" style="color: #777">{{
                        $t("cash")
                      }}</span>
                      <span v-if="tukpay"><img src="../assets/tukpay.png" class="tukpay-logo" /></span>
                    </span>
                  </span>
                  <i v-if="t.state !== 'confirmed'" class="fa fa-eye-slash" style="padding-left: 6px"
                    @click="moreInfo = false" />
                </span>
                <span v-else>
                  <span class="button is-outlined is-rounded has-text-grey" style="padding: 12px"
                    @click="triggerMoreInfo">
                    <i class="fa fa-eye fa-lg" />&nbsp;{{ $t("show") }}
                  </span>
                </span>

                <span class="contact-btns">
                  <a class="button is-white" @click="chat">
                    <i class="far fa-comment fa-lg" />
                  </a>
                  <a class="button is-white" @click="callPassenger" :disabled="noPassengerPhone">
                    <i class="fa fa-phone fa-lg" />
                  </a>

                  <a class="button is-white has-text-grey" style="width: 40px" @click="moreInfo = !moreInfo">
                    <i class="fa fa-ellipsis-h" />
                  </a>
                </span>
              </p>

              <div v-if="moreInfo || t.state === 'confirmed'">
                <p v-if="cash && tukpay" class="fare-wrapper">
                  <span class="fare is-size-5" style="background-color: #eee">฿{{ t.data.fare.cash }}</span><span
                    class="fare has-text-success is-size-5">{{
                      $t("cash")
                    }}</span>
                  <span class="fare is-size-5" style="background-color: #eee">฿{{ t.data.fare.tukpay }}</span><img
                    src="../assets/tukpay.png" class="tukpay-logo" />
                </p>
              </div>

              <p class="is-size-5 single-line no-scrollbar">
                <i class="far fa-user fa-sm" @click="close" />
                <span v-if="t.data.pax" class="pax-cnt">x{{ t.data.pax }}</span>
                <span>
                  <span class="link" @click="gotoCustomerPastLocations">{{ customerName }}</span>
                  <!-- USER TAGS -->
                  <span class="user-tags">
                    <span v-if="unitNumber" class="tag is-grey is-medium">{{
                      unitNumber
                    }}</span>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div v-if="isDelivery" style="padding-bottom: 12px; text-align: left">
            <p v-if="t.data.ref" class="single-line no-scrollbar" style="margin-bottom: 6px" @click="viewCommerceDetails">
              <span class="order-no">
                <i class="fa fa-receipt fa-sm has-text-grey" />
                &nbsp;{{ ref }}
              </span>
              <span class="shop-name">
                <i class="fa fa-store-alt fa-sm" />
                <span class="link">{{ pickupName }}</span>
              </span>
            </p>
            <div v-if="isEdited" class="is-edited" @click="contactDriverSupport()">
              <p>{{ $t("driver.order-edited-price-changed") }}</p>
              <p>{{ $t("driver.contact-support-updated-amounts") }}</p>
            </div>
            <div v-if="tukDiscount" class="is-edited has-text-warning" @click="contactDriverSupport()">
              <p class="is-flex">
                <span style="flex-grow: 1">TUK Discount {{ symbol }}{{ tukDiscount }}</span>
                <i style="font-size: 0.8em; font-weight: 400; margin-top: 2px">ติดต่อเจ้าหน้าที่ช่วยเหลือ</i>
              </p>
            </div>
            <div v-if="customerWarning" class="is-edited has-text-info" @click="contactDriverSupport()">
              <p>
                <span class="has-text-danger">{{
                  $t("driver.customer-warning")
                }}</span>
                {{ customerWarning }}
              </p>
            </div>
            <div v-if="paymentRequired" class="payment-details" :class="{ 'bg-orange': t.data.delivery.order_value < 0 }"
              @click="viewCommerceDetails">
              <div class="has-text-grey">
                <div v-if="moreInfo">
                  <p :class="{
                    'pulse big-text':
                      t.state === 'confirmed' || t.state === 'driver_arrived',
                  }" v-html="payShopX"></p>
                  <p :class="{ 'pulse big-text': t.state === 'enroute' }" v-html="collectFromCustomerX"></p>
                </div>
                <div v-else>
                  <p class="pulse big-text" v-html="payOrCollectState"></p>
                </div>
              </div>
              <span v-if="paymentReceipt" class="paid">
                <i class="fa fa-check-circle has-text-success" />&nbsp;PAID
              </span>
              <p v-if="changeFor" class="has-text-danger">
                {{ $t("driver.requested-change-for") }}
                <b>{{ symbol }}{{ changeFor }}</b>
              </p>
              <p v-if="isDigitalPayment && (moreInfo || state === 'enroute')" class="has-text-link is-flex">
                <b class="payment-method">{{
                  this.translatePayment(paymentMethod)
                }}</b>
                <marquee-text :duration="9">
                  <div style="margin-left: 20px">
                    {{ $t("driver.check-payment-received-1") }}
                    {{ $t("driver.check-payment-received-2") }}
                  </div>
                </marquee-text>
                <!-- <i style="font-size: 0.9em; margin-top: 2px">
                  <span v-if="oscillateKey">{{
                    $t("driver.check-payment-received-1")
                  }}</span>
                  <span v-else>{{
                    $t("driver.check-payment-received-2")
                  }}</span>
                </i> -->
              </p>
              <p v-if="isSOL">
                <span class="total-sol">{{ convertEURtoSOLPretty(driverCollectValue) }} SOL</span>
              </p>

              <p v-if="cashback" class="has-text-danger has-text-weight-bold">
                <span v-html="giveCashbackX"></span>
              </p>
            </div>
            <div v-else class="already-paid has-text-dark">
              {{ $t("delivery.already-paid-for") }}
            </div>
            <p v-if="t.data.delivery.require_receipt" class="enter-receipt has-text-dark">
              <span @click="editReceiptAmount">
                <i class="fa fa-receipt" style="padding: 0 3px" />&nbsp;{{
                  $t("driver.enter-receipt-amount")
                }}&nbsp;
              </span>
              <span class="is-pulled-right">
                <i v-if="t.data.receipt_price" class="fa fa-eye fa-lg" style="padding: 3px; margin-right: 6px"
                  @click="showReceiptAmount" />
                <span class="tag is-rounded" @click="editReceiptAmount">
                  <i class="fa fa-pencil-alt fa-lg has-text-info" /></span>
              </span>
            </p>
            <p v-if="importantBusinessInfo && (moreInfo || state !== 'enroute')" class="shop-note"
              @click="copy(businessNote)">
              <span v-if="signName">
                <i class="fa fa-sign" />
                <span class="note-title">{{ "Sign name" }}</span>
                {{ signName }}
                <br />
              </span>
              <span v-if="businessNote">
                <i class="fa fa-exclamation-triangle" />
                <span class="note-title">{{ $t("driver.shop-note") }}</span>
                {{ businessNote }}
                <i class="far fa-copy fa-sm has-text-black" />
              </span>
            </p>
            <p v-if="customerNote && (moreInfo || state !== 'confirmed')" class="shop-note" @click="copy(customerNote)">
              <i class="fa fa-exclamation-triangle" />
              <span class="note-title">{{ $t("driver.customer-note") }}</span>
              {{ customerNote }}
              <i class="far fa-copy fa-sm has-text-black" />
            </p>
            <p v-if="contactlessNote && (moreInfo || state === 'enroute')" class="contactless-note">
              <i class="fa fa-box" />&nbsp;{{
                $t("driver.contactless-delivery")
              }}:
              {{ contactlessNote }}
              <br />
              <i style="font-size: 0.9em; font-weight: 500">*{{
                $t("driver.leave-as-soon-as-you-have-received-payment")
              }}</i>
            </p>
            <p v-if="deliveryNotes && (moreInfo || state === 'enroute')" class="dropoff-notes"
              @click="copy(deliveryNotes)">
              <i class="far fa-comment" />&nbsp;{{ deliveryNotes }}
              <i class="far fa-copy fa-sm has-text-black" />
            </p>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-content">
          <div style="display: flex">
            <div class="left">
              <p :class="emphasizePickup ? 'emphasize' : 'deemphasize'">
                <i class="fa fa-map-marker-alt has-text-success" />
              </p>
              <p>
                <i class="fa fa-ellipsis-v fa-sm" style="color: grey" />
              </p>

              <p :class="!emphasizePickup ? 'emphasize' : 'deemphasize'">
                <i class="fa fa-map-marker-alt has-text-link" />
              </p>
            </div>
            <div class="right has-text-left">
              <p class="clamp" :style="emphasizePickup ? 'min-height: 60px' : 'min-height:48px'
                ">
                <span :class="emphasizePickup ? 'emphasize' : 'deemphasize'">
                  {{ $t("driver.pickup-at") }}

                  <a class="has-text-link" @click="prePickupDirections">
                    {{ pickupName }}
                    <i v-if="emphasizePickup" class="fa fa-directions fa-lg" />
                  </a>
                </span>
              </p>

              <p v-if="t.data.dropoff_stop" :class="!emphasizePickup ? 'emphasize' : 'deemphasize'">
                {{ $t("driver.dropoff-at") }}
                <a class="has-text-link" @click="preDropoffDirections">
                  {{ dropoffName }}
                  <i v-if="!emphasizePickup" class="fa fa-directions fa-lg" />
                </a>
              </p>
            </div>
          </div>

          <!-- <div @click="toggleIframe">
            <div v-if="showIframe" :class="iframeBtn">
              {{ $t("driver.hide-driving-directions") }}
            </div>
            <div v-else class="is-grey" :class="iframeBtn">
              {{ $t("driver.show-driving-directions") }}
            </div>
          </div> -->
        </div>
      </div>

      <div v-if="t.state === 'driver_arrived' || t.state === 'enroute'" class="shortest-route" @click="openShortestRoute">
        <i class="fa fa-route" />&nbsp;{{ $t("driver.shortest-route") }}&nbsp;
        <i class="fa fa-chevron-right" />
      </div>

      <div style="border: 2px solid lightgrey" />

      <div v-if="showIframe" class="iframe-wrapper">
        <div class="close-driving" @click="toggleIframe">
          {{ $t("driver.hide-driving-directions") }}
          &nbsp;<i class="fa fa-chevron-down" />
        </div>
        <iframe :style="iframeStyle" :src="googleMapsEmbed" scrolling="no" border="0" frameborder="no" framespacing="0"
          allowfullscreen="true">
        </iframe>
      </div>

      <img v-img class="banner" :src="t.data.delivery_confirmation_pic" />

      <input type="file" ref="file" style="display: none" accept="image/png,image/jpeg,image/jpg,image/bmp"
        @change="uploadPhoto($event)" />
    </div>

    <DriverShortestRouteMap v-if="showShortestRoute" style="z-index: 9999" :commerceOrder="commerceOrder"
      @close="showShortestRoute = false" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import photos from "@/photos";

import DriverShortestRouteMap from "@/components/DriverShortestRouteMap.vue";

export default {
  name: "DriverPanelPassengerDetail",
  components: { DriverShortestRouteMap },
  props: {
    transaction: {
      type: Object,
    },
  },
  data() {
    return {
      showShortestRoute: false,
      moreInfo: false,
      c: 0, // countdown timer
      requests: 1,
      showIframe: false,
      googleKey: "AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss",
      iframeBtn: "button is-small is-fullwidth iframe-btn",
      commerceOrder: null,
      hasNotifiedArrival: false, // to avoid sending multiple sms on arrival
      oscillateKey: true, // to oscillate check payment received text
      photoUploading: null,
    };
  },
  computed: {
    t() {
      return this.transaction;
    },
    customerWarning() {
      if (!this.t.customer) return null;
      if (!this.t.customer.data.delivery_options) return null;
      return this.t.customer.data.delivery_options.driver_warning; // warning for driver
    },
    waitingTime() {
      // for delivery: time since event_driver_arrived
      if (!this.isDelivery) return 0;
      if (this.t.state !== "driver_arrived") return 0;
      var arrivedAt = new Date(this.t.data.event_driver_arrived);
      return Math.round((new Date() - arrivedAt) / (1000 * 60)); // minutes
    },
    isEnrouteDelivery() {
      return this.t.state === "enroute" && this.isDelivery;
    },
    isEdited() {
      if (!this.paymentRequired || !this.commerceOrder) return false;
      var items = this.commerceOrder.data.order.basket.items;
      return items.find((i) => i.item.id.startsWith("~") && i.item.price);
    },
    tukDiscount() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.order.tuk_discount;
    },
    isGift() {
      return this.t.data.gift_details;
    },
    showTUKExpressReminder() {
      if (!this.isAgentOrder) return false;
      return this.t.state === "confirmed" || this.t.state === "driver_arrived";
    },
    isAgentOrder() {
      if (this.t.data.delivery) {
        return this.t.data.delivery.is_agent_order;
      }
      return false;
    },
    ref() {
      if (this.t.data.ref_prefix) {
        return this.t.data.ref_prefix + this.t.data.ref;
      }
      return "#" + this.t.data.ref;
    },
    contactlessNote() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.delivery.contactless_note;
    },
    importantBusinessInfo() {
      return this.businessNote || this.signName;
    },
    businessNote() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.delivery.business_note;
    },
    signName() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.delivery.sign_name; // || "Duke's Ping River";
    },
    customerNote() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.delivery.customer_note;
    },
    isLate() {
      console.log("c", this.c);
      if (this.t.state === "confirmed") {
        var confirmedAt = this.t.data.event_confirmed;
        var minsAgo = (new Date() - new Date(confirmedAt)) / (1000 * 60);
        return minsAgo > 15;
      }
      if (this.t.state === "enroute") {
        var enrouteAt = this.t.data.event_enroute;
        minsAgo = (new Date() - new Date(enrouteAt)) / (1000 * 60);
        return minsAgo > 20;
      }
      return false;
    },
    arriveBy() {
      if (this.t.state === "confirmed") {
        var confirmedAt = this.t.data.event_confirmed;
        return new Date(confirmedAt).getTime() + 1000 * 60 * 15;
      }
      if (this.t.state === "enroute") {
        var enrouteAt = this.t.data.event_enroute;
        return new Date(enrouteAt).getTime() + 1000 * 60 * 20;
      }
      return null;
    },
    countdown() {
      console.log("c", this.c);
      var minutes = parseInt((this.arriveBy - new Date()) / (1000 * 60));
      if (minutes < -99) return -99;
      return minutes;
    },
    deliveryNotes() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.address.notes;
    },
    iframeStyle() {
      var h = window.innerHeight + 80; // - 60;
      return `height: ${h}px; width: ${window.innerWidth}px`;
    },
    showCancel() {
      var state = this.t.state; // maybe just states confirmed, scheduled?
      return (
        state !== "cancelled_by_passenger" &&
        state !== "enroute" &&
        state !== "driver_arrived"
      );
    },
    showNoShow() {
      return this.t.state === "driver_arrived";
    },
    pickupName() {
      if (!this.t.data.pickup_stop.name) return this.$t("ride.pin-location");
      return this.shortenString(this.t.data.pickup_stop.name, 40);
    },
    dropoffName() {
      if (!this.t.data.dropoff_stop.name) return this.$t("ride.pin-location");
      return this.shortenString(this.t.data.dropoff_stop.name, 40);
    },
    payOrCollectState() {
      if (this.t.state === "enroute") {
        return this.collectFromCustomerX;
      }
      return this.payShopX;
    },
    shopPayYou() {
      var payDriverAmount = Math.abs(this.t.data.delivery.order_value);
      var amount = `<b>${this.symbol}${payDriverAmount}</b>`;
      return `<i class='fa fa-store-alt fa-sm' style='margin-right:6px'></i>
        ${this.$t("delivery.shop-pays-you")} ${amount}`;
    },
    payShopX() {
      var orderValue = this.t.data.delivery.order_value;
      if (orderValue < 0) return this.shopPayYou;
      var amount = `<b>${this.symbol}${orderValue}</b>`;
      return (
        `<i class='fa fa-store-alt fa-sm' style='margin-right:6px'></i>` +
        this.$t("delivery.pay-shop-x", { x: amount }) +
        `<span class="is-pulled-right has-text-grey" style='font-size:0.7em; margin-top:5px'>
        <i class="fa fa-user"></i> 
        <b>${this.translatePayment(this.paymentMethod)}</b></span>`
      );
    },
    collectFromCustomerX() {
      var amount = `<b>${this.symbol}${this.driverCollectValue}</b>`;
      var str = this.$t("delivery.collect-from-customer-x", { x: amount });
      return `<i class='fa fa-user' style='margin-right:6px'></i>${str}`;
    },
    changeFor() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.order.change_for;
    },
    giveCashbackX() {
      var amount = `<b>${this.symbol}${this.cashback}</b>`;
      // return this.$t("delivery.give-cashback-x", { x: amount });
      return this.$t("delivery.get-bonus-x", { x: amount });
    },
    isDelivery() {
      return this.t.data.type === "delivery";
    },
    orderValue() {
      return parseInt(this.t.data.delivery.order_value);
    },
    paymentRequired() {
      if (!this.isDelivery) return false;
      if (!this.orderValue && !this.clientCash) return false;
      var arr = ["cash", "promptpay", "bank-transfer", "sol"];
      return arr.includes(this.t.data.delivery.payment_method);
      // if (this.t.data.delivery.payment_method === "cash") return true;
      // return false;
    },
    paymentMethod() {
      if (!this.isDelivery) return null;
      return this.t.data.delivery.payment_method;
    },
    isDigitalPayment() {
      var digitalPaymentMethods = ["bank-transfer", "promptpay"];
      return digitalPaymentMethods.includes(this.paymentMethod);
    },
    isSOL() {
      if (!this.isDelivery) return false;
      if (!this.orderValue) return false;
      return this.t.data.delivery.payment_method === "sol";
    },
    isLalamove() {
      if (!this.t.data.delivery) return null;
      return this.t.data.delivery.lalamove;
      // return this.t.data.lalamove_order_id;
    },
    clientCash() {
      return parseInt(this.t.data.fare.client || this.t.data.fare.cash); // for backward compatability
    },
    orderRemit() {
      return parseInt(this.t.data.delivery.remit || 0);
    },
    driverCollectValue() {
      if (this.isLalamove) return this.orderValue;
      // var sum = parseInt(this.orderValue) + parseInt(this.t.data.fare.cash);
      var sum = this.orderValue + this.clientCash + this.orderRemit;
      if (this.cashback) return sum - this.cashback;
      return sum;
    },
    cashback() {
      return this.t.data.delivery.cashback;
    },
    symbol() {
      return this.currencySymbol(this.t.business.country);
    },
    customerName() {
      if (!this.t) return null;
      return this.t.customer.name || this.t.customer.phone_number;
    },
    isTaxi() {
      return this.t.workflow_type_name === "Taxi";
    },
    cash() {
      if (!this.t.data.fare) return false;
      if (this.t.data.fare.cash !== 0) return true;
      // if (this.clientCash !== 0) return true;
      return false;
    },
    tukpay() {
      if (!this.t.data.fare) return false;
      if (this.t.data.fare.tukpay !== 0) return true;
      if (this.suggestedPriceDiff > 0) return true; // eat any difference at tukpay
      return false;
    },
    suggestedPriceDiff() {
      if (!this.t.data.fare) return false;
      if (!this.t.data.suggested_price) return false;
      return this.t.data.suggested_price - this.t.data.fare.price;
    },
    noPassengerPhone() {
      // evaluate whatever you need to determine disabled here...
      // returns true if passenger does not have a valid phone number
      return this.t.customer.phone_number.length < 10;
    },
    unitNumber() {
      if (!this.t.customer.role) return null;
      if (!this.t.customer.role.data) return null;
      if (!this.t.customer.role.data.unit_number) return null;
      return `Unit ${this.t.customer.role.data.unit_number}`;
    },
    businessPic() {
      var placeholder = this.$store.state.menuItemPlaceholderPic; // change to a shop cartoon?
      if (!this.t.business) return placeholder;
      return this.t.business.profile_pic_url || placeholder;
    },
    customerPic() {
      if (this.t.data.type === "delivery" && this.t.state === "confirmed") {
        return this.businessPic;
      }
      return this.t.customer.profile_pic_url || this.fallbackProfPic();
    },
    fareType() {
      return this.t.data.price;
    },
    state() {
      if (!this.t) return null;
      return this.t.state;
    },
    emphasizePickup() {
      var arr = ["driver_arrived", "enroute"];
      return !arr.includes(this.state); // inverse
    },
    pickupDirectionsURL() {
      if (!this.t.data.pickup_stop) return;
      // var url = "https://www.google.com/maps?saddr=My+Location&daddr=";
      var current = this.$store.state.userState;
      var scoords = `${current.lat},${current.lon}`;
      var dcoords = `${this.t.data.pickup_stop.lat},${this.t.data.pickup_stop.lon}`;
      // return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`; //url + coords;
      // return `https://www.google.com/maps/dir/?api=1&origin=${scoords}&destination=${dcoords}&travelmode=driving`
      return this.$h.googleMapsDirectionsURL(scoords, dcoords)
    },
    dropoffDirectionsURL() {
      if (!this.t.data.dropoff_stop) return;
      // var url = "https://www.google.com/maps?saddr=My+Location&daddr=";
      var current = this.$store.state.userState;
      var scoords = `${current.lat},${current.lon}`;
      var dcoords = `${this.t.data.dropoff_stop.lat},${this.t.data.dropoff_stop.lon}`;
      // return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`;
      return this.$h.googleMapsDirectionsURL(scoords, dcoords)
    },
    pickupMapEmbed() {
      if (!this.t.data.pickup_stop) return;
      var current = this.$store.state.userState;
      var scoords = `${current.lat},${current.lon}`;
      var dcoords = `${this.t.data.pickup_stop.lat},${this.t.data.pickup_stop.lon}`;
      return `https://www.google.com/maps/embed/v1/directions?key=${this.googleKey}&origin=${scoords}&destination=${dcoords}&mode=driving&region=th&language=th&maptype=roadmap`;
    },
    dropoffMapEmbed() {
      if (!this.t.data.dropoff_stop) return;
      var current = this.$store.state.userState;
      var scoords = `${current.lat},${current.lon}`;
      var dcoords = `${this.t.data.dropoff_stop.lat},${this.t.data.dropoff_stop.lon}`;
      return `https://www.google.com/maps/embed/v1/directions?key=${this.googleKey}&origin=${scoords}&destination=${dcoords}&mode=driving&region=th&language=th&maptype=roadmap`;
    },
    googleMapsEmbed() {
      if (this.emphasizePickup) return this.pickupMapEmbed;
      return this.dropoffMapEmbed;
    },
    paymentReceipt() {
      if (!this.commerceOrder) return null;
      return this.commerceOrder.data.payment_receipt_pic;
    },
  },
  mounted() {
    // EventBus.$on("OPEN_PASSENGER_DETAIL", t => { if (!t.data.eta) this.sendEta() });
    this.getCommerceOrder();
    setInterval(() => (this.c += 1), 10 * 1000); // countdown timer, should destroy?
    setInterval(() => (this.oscillateKey = !this.oscillateKey), 1500);
  },
  deactivated() {
    this.showIframe = false;
    this.showShortestRoute = false;
  },
  methods: {
    gotoCustomerPastLocations() {
      this.goto(`past_addresses/${this.t.customer.id}`);
    },
    openShortestRoute() {
      // overlay a map and draw route
      this.showShortestRoute = true;
    },
    logAgentOrder() {
      console.log("is_agent_order", this.t);
    },
    close() {
      EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
    },
    copy(txt) {
      this.$copyText(txt);
      this.infoToast("Copied to clipboard!<br>" + txt);
    },
    triggerMoreInfo() {
      if (!this.moreInfo) {
        this.moreInfo = true;
        setTimeout(() => (this.moreInfo = false), 6000);
      } else {
        this.moreInfo = false;
      }
    },
    viewDeliveryConfirmationPic() {
      this.$el.querySelector(".banner").click();
    },
    triggerUploadPhoto() {
      this.$refs.file.click();
      var loader = this.loadingDots("lightblue");
      setTimeout(() => loader.hide(), 5000);
    },
    uploadPhoto(e) {
      var dir = "delivery_confirmation";
      var filename = this.$shortid.generate(); //${this.t.id}`;
      var businessID = this.t.business_id;
      var callback = this.attachDropoffPhoto;
      this.photoUploading = this.loadingDots("lightgreen");
      photos.uploadPhoto(e, this.$store, callback, dir, filename, businessID);
    },
    attachDropoffPhoto(picURL) {
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            data: { delivery_confirmation_pic: picURL },
          },
        })
        .then(() => {
          this.successToast("Delivery Pic Uploaded");
          this.log("upload_delivery_pic_success", this.t.id);
          // var name = this.$store.getters.realName;
          // var msg = `Driver [ ${name} ] uploaded delivery confirmation pic`;
          // this.sendSuperuserNotification(msg);
          this.updateTransactionsForDriver(true);
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => this.photoUploading.hide());
    },
    editReceiptAmount() {
      this.$emit("editReceiptAmount", this.t);
      this.close();
    },
    showReceiptAmount() {
      var amount = this.symbol + this.t.data.receipt_price;
      var msg = `You entered receipt amount: <b>${amount}</b>`;
      this.infoToast(msg);
    },
    lateInfo() {
      var msg = this.$t("driver.please-hurry");
      this.errorToast(msg);
    },
    toggleIframe() {
      this.showIframe = !this.showIframe;
      if (this.showIframe) {
        var loader = this.loadingDots("black");
        setTimeout(() => loader.hide(), 1000);
        //   var opt = { top: 574, behavior: "smooth" };
        //   setTimeout(() => this.$refs.scrollable.scrollBy(opt), 1000);
      }
    },
    deliveryPickupIssue() {
      var red = this.bulmaColor("danger");
      var cancelCode = Math.floor(Math.random() * 900) + 100; // random 3-digit number 100 - 999
      var txtCancel = this.$t("driver.enter-code-to-cancel");
      var title = this.$t("driver.delivery-pickup-issue");
      var txt1 = this.$t("driver.delivery-pickup-issue-1");
      var txt2 = this.$t("driver.delivery-pickup-issue-2");
      this.$swal({
        html: `<div style='text-align:left'>
          <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-exclamation-triangle' style='color: ${red}'></i>&nbsp;${title}
          </p>
          <p style='margin-bottom:10px'>${txt1}</p>
          <p style='margin-bottom:10px'><i>${txt2}</i></p>
          <p>${txtCancel}: <b>${cancelCode}</b></p>
          </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("driver.abort-the-job"),
        confirmButtonColor: red,
        cancelButtonText: this.$t("okay"),
        input: "number", //"text",
        inputValidator: (val) => {
          if (!val || parseInt(val) !== cancelCode) return txtCancel;
          // if (!val || val.length < 10) return "Why are you aborting the job?";
        },
      }).then((val) => {
        if (!val.value) return;
        var driver = this.$store.getters.getNameAndNumber;
        var msg = `⛔️ ☢️ ABORTED DELIVERY (${cancelCode}): ${driver} @ ${this.pickupName}`;
        this.sendSuperuserNotification(msg);
        this.abort();
      });
    },
    abort() {
      this.$store.commit("rejectTransaction", this.t.id);
      this.log("driver_cancelled", {
        driver_id: this.userID(),
        transaction_id: this.t.id,
      });
      var loader = this.loadingDots();
      this.t.is_updating = true; // add flag
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: { state: "cancelled_by_driver" },
        })
        .then(() => this.updateTransactionsForDriver(true))
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.close();
        });
    },
    copyCoords(coords) {
      var coordsString = `${coords.lat},${coords.lon}`;
      this.$copyText(coordsString);
      this.infoToast("Copied coords: " + coordsString, "top")
    },
    prePickupDirections() {
      this.copyCoords(this.t.data.pickup_stop);
      if (this.emphasizePickup) {
        window.open(this.pickupDirectionsURL, "_blank");
      } else {
        // this.errorToast("After pickup go to dropoff location");
        this.confirmDirections();
      }
    },
    preDropoffDirections() {
      this.copyCoords(this.t.data.dropoff_stop);
      if (!this.emphasizePickup) {
        window.open(this.dropoffDirectionsURL, "_blank");
      } else {
        this.errorToast("Go to pickup location first");
        // this.confirmDirections();
      }
    },
    confirmDirections() {
      var green = this.bulmaColor("primary");
      var blue = this.bulmaColor("info");
      var txt1 = this.$t("driver.where-are-you-going-now");
      var txt2 = this.$t("driver.now-i-am-going-to");
      this.$swal({
        html: `<div style='text-align:left; font-size:1.2em'>
        <p style='margin-bottom:12px'>
        <i class='fa fa-map-marker-alt' style='color: orange'></i>&nbsp;${txt1}
        </p>
        <p>${txt2}</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("driver.pickup"),
        cancelButtonText: this.$t("driver.dropoff"),
        confirmButtonColor: `${this.emphasizePickup ? green : blue}`,
        cancelButtonColor: `${!this.emphasizePickup ? green : blue}`,
      }).then((val) => {
        if (val.value) {
          window.open(this.pickupDirectionsURL, "_blank");
        } else if (val.dismiss === "cancel") {
          window.open(this.dropoffDirectionsURL, "_blank");
        }
      });
    },
    deliveryArrived() {
      // var txt = `Customer is notified of your arrival<br><i>Knock or ring the doorbell too</i> 😎`;
      var txt = `ลูกค้าจะได้รับแจ้งการมาถึงของคุณ<br><i>เคาะหรือกดกริ่งด้วย</i> 😎<br>โทรหาลูกค้าทางโทรศัพท์ได้ด้วย 📞`;
      this.infoToast(txt);

      var msg = `Your delivery has arrived! You can call the driver if you do not see them.`;
      if (!this.hasNotifiedArrival) {
        this.sendMessage(msg, "push", this.t.customer.id); // local func that does both push/sms
      } else {
        this.sendPushNotification(msg, this.t.customer.id); // just push notification
      }
      this.hasNotifiedArrival = true;
    },
    showScheduleTag(t) {
      var states = ["confirmed", "driver_arrived", "scheduled"];
      return states.includes(t.state);
    },
    humanTimeOrTimeAgo(t) {
      if (this.humanTime(t) !== "Passed") return this.humanTime(t);
      return this.timeAgo(t.data.scheduled_time);
    },
    getCommerceOrder() {
      // only commerce deliveries will have this
      if (!this.t.data.commerce_transaction_id) return;
      this.$store
        .dispatch("getTransactionByID", this.t.data.commerce_transaction_id)
        .then((res) => (this.commerceOrder = res.data))
        .catch((err) => this.apiError(err));
    },
    viewCommerceDetails() {
      this.getCommerceOrder(); // update commerce order async
      if (!this.commerceOrder) this.viewOrderDetails();
      else EventBus.$emit("COMMERCE_ORDER_DRIVER_MODAL", this.commerceOrder);
    },
    // old way, simple popup, DEPRECATED
    viewOrderDetails() {
      var orderValue = parseInt(this.t.data.delivery.order_value);
      var deliveryFee = parseInt(this.t.data.fare.price);
      var total = orderValue + deliveryFee;
      var payment = this.translatePayment(this.t.data.delivery.payment_method);
      var txt1 = this.$t("delivery.payment-method");
      var txt2 = this.$t("price");
      var txt3 = this.$t("home.delivery");
      var txt4 = this.$t("total");
      var symbol = this.currencySymbol(this.t.business.country);
      this.$swal({
        imageUrl: this.t.data.delivery.receipt_pic,
        imageHeight: 400,
        html: `<div style='text-align:left'>
        <i>${txt1}: <strong>${payment}</strong></i><br>
        ${txt2}: ${symbol}${orderValue}<br>
        ${txt3}: ${symbol}${deliveryFee}<br>
        <strong>${txt4}: ${symbol}${total}</strong><br>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    editTransactionAlighted() {
      if (!this.isEnrouteDelivery || this.t.data.delivery_confirmation_pic) {
        return this.editTransaction("alighted");
      }
      var uploadIcon = "<i class='fa fa-upload'></i>&nbsp;";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size: 1.1em; margin-bottom:12px'>
          <i class='fa fa-camera'></i>&nbsp;
          ${this.$t("driver.submit-delivery-photo")}
        </p>
        <p>${this.$t("driver.take-photo-all-deliveries")}</p>
        </div>`,
        allowOutsideClick: true,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `${uploadIcon}${this.$t("upload")}`,
        cancelButtonText: this.$t("i-forgot"),
      }).then((val) => {
        if (val.dismiss === "close" || val.dismiss === "backdrop") {
          this.infoToast("Take delivery photo now");
        } else if (val.dismiss === "cancel") {
          this.editTransaction("alighted");
        } else {
          this.triggerUploadPhoto();
        }
      });
    },
    // editTransaction(t, state) {
    editTransaction(state) {
      var payload = {
        transaction: this.t, //t,
        state: state,
      };
      EventBus.$emit("EDIT_TRANSACTION_FROM_PASSENGER_DETAIL", payload);
      this.close();
    },
    // editPrice(t, price) {
    //   var loader = this.loadingDots();
    //   t.is_updating = true; // add flag
    //   this.$store
    //     .dispatch("patchTransaction", {
    //       transactionID: t.id,
    //       data: { data: { suggested_price: parseInt(price) } },
    //     })
    //     .then(() => this.updateTransactionsForDriver(true))
    //     .catch((err) => this.apiError(err))
    //     .finally(() => {
    //       loader.hide();
    //       this.thankYou();
    //       this.close();
    //     });
    // },
    // pricingIssue() {
    //   this.$swal({
    //     html: `
    //     <div style='text-align:left'>
    //     <p style='margin-bottom:10px; font-size:1.2em'>Need help on this order?</p>
    //     <p>${this.$t("driver.pricing-issue")}</p>
    //     </div>`,
    //     input: "number",
    //     inputPlaceholder: "฿",
    //     showCancelButton: true,
    //     showCloseButton: true,
    //     confirmButtonText: this.$t("driver.submit-price"),
    //     cancelButtonText: this.$t("driver.not-pricing-issue"),
    //     inputValidator: (val) => {
    //       if (!val || val.length === 0) return this.$t("driver.enter-price");
    //       var price = this.t.data.fare.price;
    //       if (val <= price)
    //         return `${this.$t("driver.current-price-warning")} ฿${price}`;
    //     },
    //   }).then((val) => {
    //     if (val.value) this.editPrice(this.t, val.value);
    //   });
    // },
    cancel() {
      var cancelCode = Math.floor(Math.random() * 900) + 100; // random 3-digit number 100 - 999
      var red = this.bulmaColor("danger");
      var txt = this.$t("logistics.cancel-are-you-sure");
      var txt2 = this.$t("driver.enter-code-to-cancel");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class="fa fa-exclamation-triangle" style='color:${red}'></i>&nbsp;
        ${this.$t("cancel")}
        </p>
        <p style='margin-bottom:10px'>${txt}</p>
        <p>${txt2}: <b>${cancelCode}</b></p>
        </div>`,
        input: "number",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("yes-cancel"),
        confirmButtonColor: red,
        cancelButtonText: this.$t("no"),
        inputValidator: (val) => {
          if (!val || parseInt(val) !== cancelCode) return txt2;
        },
      }).then((val) => {
        if (!val.value) return; // not canceled
        this.$store.commit("setDriverCancelledAt");
        // change state to rejected / cancelled
        var driver = this.$store.getters.getNameAndNumber;
        var msg = `⛔️ CANCELED DELIVERY (${cancelCode}) ${driver} @ ${this.pickupName}`;
        this.sendSuperuserNotification(msg);
        this.$store.commit("rejectTransaction", this.t.id);
        this.log("driver_cancelled", {
          driver_id: this.userID(),
          transaction_id: this.t.id,
        });
        var loader = this.loadingDots();
        this.t.is_updating = true; // add flag
        this.$store
          .dispatch("patchTransaction", {
            transactionID: this.t.id,
            data: { state: "cancelled_by_driver" },
          })
          .then(() => this.updateTransactionsForDriver(true))
          .catch((err) => this.apiError(err))
          .finally(() => {
            loader.hide();
            this.close();
          });
      });
    },
    noShow() {
      this.$swal({
        // title: this.$t("driver.no-show-title"), //"We're Sorry To Hear That",
        html: `<div style='text-align:left'>
<p style='font-size:1.2em'><i class="fa fa-sad-tear fa-lg"></i>&nbsp;
${this.$t("driver.no-show-title")}</p><br>
${this.$t("driver.no-show-1")}<br><br>
${this.$t("driver.no-show-2")}<br><br>
${this.$t("driver.no-show-3")}</div>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: this.$t("yes-no-show"),
        confirmButtonText: this.$t("cancel-no-show"),
      }).then((result) => {
        this.console("reject result", result);
        if (result.dismiss === "cancel") {
          var loader = this.loadingDots();
          this.t.is_updating = true; // add flag
          this.$store
            .dispatch("patchTransaction", {
              transactionID: this.t.id,
              data: { state: "no_show" },
            })
            .then(() => this.updateTransactionsForDriver(true))
            .catch((err) => this.apiError(err))
            .finally(() => {
              loader.hide();
              this.close();
            });
        }
      });
    },
    chat() {
      // if (!this.transaction.data.eta) return this.sendEta();
      var title = this.$t("driver.message-customer");
      this.$swal({
        html: `<div style='font-size:1.2em; text-align:left'>
        <i class='far fa-comment fa-lg'></i>&nbsp;${title}</div`,
        input: "text",
        confirmButtonText: this.$t("send"),
        // cancelButtonText: this.$t("cancel"),
        showCloseButton: true,
        showCancelButton: false,
      }).then((val) => {
        if (val.value) {
          console.log(val.value);
          this.sendMessage(val.value, "push", this.t.customer.id);
        }
      });
    },
    // move to shared func
    sendMessage(msg, type, userID) {
      this.$toast.open({
        type: "info",
        message: "<i class='fa fa-spinner fa-spin'></i>",
        position: "top",
        duration: 1000,
      });
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: userID,
          message: msg,
          type: type, // send type: sms or push
        })
        .then(() => {
          this.successToast(this.$t("driver.message-sent-to-customer"), "top");
        })
        .catch((err) => {
          if (type === "push") {
            this.infoToast("Push msg failed, sending SMS", "top");
            this.sendMessage(msg, "sms", userID);
          } else this.apiError(err); // first try sms if push err
        });
    },
    sendEta() {
      this.$swal({
        title: this.$t("driver.how-many-minutes"),
        html: `<i class="fa fa-user-clock fa-4x" style="color:lightgreen"/>`,
        input: "number",
        inputPlaceholder: `5 ${this.$t("minutes")}`,
        showCancelButton: true,
        confirmButtonText: this.$t("send"),
        cancelButtonText: this.$t("cancel"),
        inputValidator: (val) => {
          if (!val || val.length === 0)
            return this.$t("driver.enter-time-in-minutes");
        },
      })
        .then((val) => {
          if (val.value) {
            var eta = parseInt(val.value);
            this.$store
              .dispatch("patchTransaction", {
                transactionID: this.t.id,
                data: { data: { eta: eta } },
              })
              .then(() => {
                this.t.data.eta = eta;
                this.updateTransactionsForDriver(true);
              });
            this.thankYou();
            this.close();
          }
        })
        .catch((err) => this.apiError(err));
    },
    callPassenger() {
      this.infoToast("Calling Customer...");
      var mobile = this.t.customer.phone_number;
      window.location.href = `tel:${mobile}`;
    },
    callRecipient() {
      this.infoToast("Calling Recipient...");
      this.$copyText(this.t.data.gift_details.recipient_phone);
      this.callPhoneNumber(this.t.data.gift_details.recipient_phone);
    },
  },
};
</script>

<style scoped>
/* .driver-panel-passenger-detail {
  max-height: 10vh;
  overflow: hidden;
} */
.subtitle {
  margin-bottom: 0;
}

.total-sol {
  /* margin-left: 6px; */
  background-color: var(--crypto-secondary);
  /* color: var(--crypto-primary); */
  padding: 0 4px;
  border-radius: 3px;
  font-weight: 500;
  color: black;
}

.card .media {
  overflow: hidden;
}

.card-content {
  padding: 12px;
}

.user {
  padding-bottom: 0;
}

.call-chat {
  padding-bottom: 0px;
}

.bottom-wrapper {
  z-index: 1;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: auto;
  min-height: 180px;
  max-height: calc(100vh - 150px);
  overflow: scroll;
  width: 100%;
  background-color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.2);
  border-top: 6px solid rgba(0, 170, 255, 0.6);
}

/* .dark .bottom-wrapper,
.dark .is-white {
  background-color: #1c37bd;
  color: white;
} */
.profile-pic {
  object-fit: cover;
  height: 80px;
  width: 80px;
  border-radius: 3px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

a:active,
a:visited {
  color: blue;
}

.tag {
  padding: 0 6px;
}

.media-left {
  margin-right: 6px;
  /* margin-bottom: 6px; */
}

.delete {
  background-color: rgba(255, 0, 0, 0.5);
}

.card .media:not(:last-child) {
  margin-bottom: 0px;
}

@keyframes pulse-text {
  0% {
    text-shadow: 0 0 0 yellow;
  }

  50% {
    text-shadow: 0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow,
      0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow,
      0 0 14px yellow, 0 0 14px yellow, 0 0 14px black;
  }

  100% {
    text-shadow: 0 0 0 yellow;
  }
}

.fa-user,
.fa-store-alt {
  width: 30px;
  text-align: center;
  color: grey;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
}

/* .user-tags {
  margin-left: 30px;
} */
.user-tags .tag {
  margin-left: 4px;
  /* font-size: 0.9em; */
}

.fare {
  padding: 4px;
  font-weight: 500;
  line-height: 36px;
  border-radius: 4px;
}

.fare span {
  /* vertical-align: middle; */
  height: 100%;
}

.left {
  height: 80px;
  width: 30px;
}

.right {
  padding-left: 10px;
  width: calc(100vw - 30px);
}

.fare-wrapper {
  margin-left: 4px;
  /* margin-top: 6px; */
  margin-bottom: 10px;
}

.pax-cnt {
  margin-left: -4px;
  margin-right: 4px;
  font-size: 0.8em;
  font-weight: 550;
}

.is-flex {
  gap: 5px;
}

.is-flex .button {
  flex: 1;
}

.emphasize {
  font-size: 1.5em;
  border-radius: 3px;
  /* margin-bottom: 0; */
}

.deemphasize {
  opacity: 0.6;
  filter: blur(1.5px);
}

.pulse {
  animation: pulse-text 1.5s ease-out infinite;
}

.emphasize .fa-map-marker-alt {
  animation: pulse-text 1.5s ease-out infinite;
  border-radius: 10px;
  /* padding-bottom: 0; */
}

.tukpay-logo {
  height: 22px;
  display: inline-block;
  position: relative;
  top: 6px;
  margin-left: 4px;
}

.scheduled {
  width: 100%;
  font-weight: 550;
  font-size: 0.9em;
  padding: 6px;
  background-color: #ccc;
  /* margin-bottom: 4px; */
}

.tuk-express {
  text-align: left;
  width: 100%;
  padding: 12px;
  background-color: black;
}

.contact-btns {
  /* float: right; */
  position: absolute;
  right: 3px;
}

.contact-btns .button {
  width: 50px;
  color: var(--link);
}

.order-no {
  text-align: center;
  display: inline-block;
  width: 80px;
  border-radius: 3px;
  border: 1.5px dotted grey;
  margin-right: 6px;
  font-weight: 550;
  background-color: lightcyan;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  box-shadow: 0 0 2px grey;
  font-size: 1.2em;
  line-height: 1.2em;
}

.shop-name {
  font-weight: 500;
  color: grey;
}

.close-btn {
  padding: 9px;
}

.iframe-btn {
  margin-bottom: -16px;
  margin-top: 4px;
  border-radius: 0;
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
}

.iframe-wrapper {
  /* position: absolute;
  top: 0; */
  /* bottom: -5px; */
  /* z-index: 9999999;
  height: 100vh; */
  margin-bottom: 16px;
  background-color: black;
}

.close-driving {
  /* text-align: left; */
  position: absolute;
  bottom: 0;
  width: 100vw;
  background-color: rgb(36, 36, 35);
  padding: 8px 12px;
  color: white;
  /* padding-left: 55px; */
  /* font-size: 1.2em; */
}

.paid {
  float: right;
  margin-top: -26px;
  margin-right: -4px;
  background-color: white;
  padding: 0 3px;
  /* border-radius: 3px; */
  border-radius: 20px;
  /* box-shadow: 0 0 1px grey; */
  border: 1px solid #ddd;
}

.payment-details {
  background-color: lightcyan;
  padding: 4px 8px;
  border-radius: 3px;
  box-shadow: 0 0 1px #aaa;
}

.already-paid {
  background-color: lightgreen;
  padding: 4px 8px;
  border-radius: 3px;
}

.enter-receipt {
  background-color: #dde;
  padding: 4px 8px;
  border-radius: 3px;
  margin-top: 1px;
}

.dropoff-notes {
  background-color: yellow;
  padding: 4px 8px;
  border-radius: 3px;
  margin-top: 1px;
  box-shadow: 0 0 1px #aaa;
  max-height: 76px;
  overflow: scroll;
}

.contactless-note {
  background-color: rgb(255, 202, 122);
  padding: 4px 8px;
  border-radius: 3px;
  margin-top: 1px;
  box-shadow: 0 0 1px #aaa;
  max-height: 76px;
  overflow: scroll;
}

.shop-note {
  background-color: rgb(255, 166, 236);
  padding: 4px 8px;
  border-radius: 3px;
  margin-top: 1px;
  box-shadow: 0 0 1px #aaa;
  max-height: 76px;
  overflow: scroll;
}

.countdown-timer {
  background-color: var(--danger);
  color: white;
  padding: 8px;
  font-size: 1.4em;
}

.countdown {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  padding: 0 3px;
  margin-left: 6px;
  color: #333;
  font-weight: 550;
  text-shadow: 0 0 1px grey, 0 0 2px white;
}

.progress {
  margin-bottom: 0;
  border-radius: 0;
}

.banner {
  display: none;
}

.big-text {
  color: black;
  font-size: 1.2em;
}

.bg-orange {
  background-color: rgb(255, 199, 94);
}

.note-title {
  font-size: 0.9em;
  font-weight: 550;
  margin-left: 4px;
}

.is-edited {
  color: var(--danger);
  font-weight: 700;
  background-color: black;
  padding: 4px 8px;
  border-radius: 3px;
}

.button.is-medium {
  padding: 14px;
}

.shortest-route {
  /* text-align: left; */
  padding: 9px;
  background-color: #ddd;
}

.payment-method {
  border: 1px solid grey;
  padding: 0 3px;
  border-radius: 3px;
  margin-left: -3px;
  white-space: nowrap;
}
</style>

